import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MessageService, Message, ConfirmationService } from 'primeng/api';

import { ICaseList } from '../../shared/classes/case-list';
import { CaseService } from '../../services/case.service';
import { UtilitiesService } from '../../services/utilities.service';
import { DictionaryService } from 'src/app/services/dictionary.service';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-case-lookup',
  templateUrl: './case-lookup.component.html'
})
export class CaseLookupComponent implements OnInit {
    refreshMode: string;
    caseList: ICaseList[];
    cols: any[];
    curYear: number;
    yearList: string[];
    rollYearList: string[];
    // tslint:disable-next-line:variable-name
    private _caseYear: number;
    caseYear: number;
    //
    displayState: any = {
        workingDiv: false,
        filterDiv: false,
        gridDiv: false,
        altLookup: false
    };

    searchString = {
        caseNum: '',
        APN: '',
        applicant: '',
        appraiserId: ''
    };
    altSearchString = {
        complexCase: false,
        specialCaseIdentifier: '',
        rollYear: ''
    };

    appraiserChoiceList: any[];
    assessorSpecialCaseChoiceList = [];

    userRole: string;
    allowNewCase = false;

    /*
    get caseYear(): number {
        return this._caseYear;
    }

    // changing the value of CaseYear should trigger this function...
    set caseYear(value: number) {
        if (value !== this._caseYear) {
            this._caseYear = value;
            this.utilService.doAudit(this.caseYear, 'case year changed:');
            this.loadCaseList(this.caseYear);
        }
    }
     */

    constructor(private caseService: CaseService, private utilService: UtilitiesService, private dictService: DictionaryService,
                private router: Router, private messageService: MessageService, private confirmationService: ConfirmationService,
                private cookieService: CookieService, private route: ActivatedRoute) {
      this.refreshMode = route.snapshot.paramMap.get('refreshMode');

    }

    ngOnInit() {
        this.cols = [
            { field: 'id'},
            { field: 'caseNumber', header: 'Case #' },
            { field: 'dateReceived', header: 'Dt Received' },
            { field: 'applicantName', header: 'Applicant' },
            { field: 'agencyName', header: 'Agency' },
            { field: 'propSecured', header: 'Secured?' },
            { field: 'propNumber', header: 'Prop Number' },
            { field: 'situs', header: 'Situs'},
            { field: 'status', header: 'Status' }

        ];
        const year = this.route.snapshot.paramMap.get('rollYear');
        this.curYear = (new Date()).getFullYear();
        this.displayState.filterDiv = true;
        this.getYearList(); // construct list of years made available for searching/editing - rod
        this.dictService.getAssessorList().subscribe(data => {
            if (data) {
                this.utilService.doAudit(data, 'Appraiser dictionary:');
                this.appraiserChoiceList = data;
                this.appraiserChoiceList.unshift( { id: 0, name: 'Not Assigned', isActive: false });
                this.appraiserChoiceList.unshift({});
                // FILTER ON isActive flag??
            }
        });
        // get special case identifiers dictionary items
        this.dictService.getCaseDictionaries('specialcase').subscribe(data => {
          if (data) {
            data.unshift({}); // Inserts blank at the start of the array
            this.assessorSpecialCaseChoiceList = data;
            // this.assessorSpecialCaseChoiceList.push({});
          }
        });
        //
        if (year) {
            this.caseYear = parseInt(year, 10);
        } else {
            // this.caseYear = this.curYear;  // for TESTING ONLY! (set to previous year) - rod
        }

        this.applySecurity();   // use Role to determine what functionality user will be allowed to access
        // reload previous case list...
        this.restoreCaseList();
    }

    applySecurity() {
        let uRole = this.cookieService.get('userRole'); // get the role from login cookie
        if (uRole) {
          this.userRole = uRole;
        } else {
          uRole = this.userRole;
        }
        if (uRole.includes('Clerk of the') || uRole.includes('Administrator')) { this.allowNewCase = true; }
        return;
    }

    // generate a list of years to display, based on current year
    getYearList() {
        this.yearList = [];
        const baseYr = this.curYear - 16;
        for (let yr = this.curYear; yr > baseYr; yr--) {
          this.yearList.push(yr.toString());
        }
        this.rollYearList = [];
        for (let yr = this.curYear; yr > baseYr; yr--) {
          this.rollYearList.push(yr.toString() + '/' + (yr + 1).toString());
        }
        // console.log(this.yearList);
    }
    changeYear() {
      this.utilService.doAudit(this.caseYear, 'case year changed:');
      if (!this.caseYear) {
        this.caseList = [];
        return;
      }
      this.loadCaseList(this.caseYear);
    }
    restoreCaseList() {
      this.utilService.doAudit(this.refreshMode,'restore mode: ' + this.refreshMode);
      if (this.refreshMode != "1") {
        // no refresh necessary... should we clear out previous search results??
        return;
      }
      this.displayState.gridDiv = false;
      this.displayState.workingDiv = true;
      let caseL = this.utilService.getArray('case-list');
      if (caseL) {
        this.caseList = caseL;
      }
      let searchStr = this.utilService.getArray('case-filter');
      this.utilService.doAudit(searchStr, 'case-filter:');
      this.displayState.gridDiv = true;
      this.displayState.workingDiv = false;
    }
    loadCaseList(year: number) {
        this.displayState.gridDiv = false;
        this.displayState.workingDiv = true;
        // if they're viewing by year, clear out any search (filter) items...
        this.searchString = {
            caseNum: '',
            APN: '',
            applicant: '',
            appraiserId: ''
        };
        if (!year) {
          this.caseList = [];
          this.displayState.workingDiv = false;
        }
        else {
          this.caseService.getCaseListByYear(year).subscribe (data => {
              this.utilService.doAudit(data, 'case list for year: ' + year);
              this.caseList = [];
              this.caseList = data;
              this.displayState.workingDiv = false;
              this.displayState.gridDiv = true;
          });
        }
    }

    // search for a specific Case#
    findByCaseNum() {
        if (!this.searchString.caseNum) {
            this.showToast({ key: 'toast', severity: 'error', detail: 'Please enter a Case#', summary: 'Info' });
            return;
        }
        this.searchForCase('casenum', this.searchString.caseNum);
    }

    findByAPN() {
        if (!this.searchString.APN) {
            this.showToast({ key: 'toast', severity: 'error', detail: 'Please enter an APN', summary: 'Info' });
            return;
        }
        const apn = this.searchString.APN.replace(/-/g, '');
        this.searchForCase('propapn', apn);
    }

    findByApplicant() {
        if (!this.searchString.applicant) {
            this.showToast({ key: 'toast', severity: 'error', detail: 'Please enter a (partial) Applicant LAST name', summary: 'Info' });
            return;
        }
        this.searchForCase('applicant', this.searchString.applicant);
    }

    findByAppraiser() {
        if (!this.searchString.appraiserId) {
            this.showToast({ key: 'toast', severity: 'error', detail: 'Please select an Appraiser', summary: 'Info' });
            return;
        }
        this.utilService.doAudit(this.searchString, 'searching by appraiser:');
        this.searchForCase('appraiser', this.searchString.appraiserId);
    }
    findByAltSearch() {
      if (!this.altSearchString.specialCaseIdentifier && !this.altSearchString.rollYear && !this.altSearchString.complexCase) {
        this.showToast({ key: 'toast', severity: 'error', detail: 'Please select at lease ONE of the Alt Search filters', summary: 'Info' });
        return;
      }

      this.displayState.gridDiv = false;
      this.displayState.workingDiv = true;
      let filterString = {
        complexCase: this.altSearchString.complexCase ?? false,
        specialCase: this.altSearchString.specialCaseIdentifier ?? '',
        rollYear: this.altSearchString.rollYear ?? ''
      }
      this.utilService.doAudit(filterString, 'filterString:');
      this.caseService.searchCaseByAlt(filterString).subscribe (data => {
        this.utilService.doAudit(data, 'response from searchCaseByAlt');
        this.displayState.workingDiv = false;
        if (data) {
          // IFF searchType === "appraiser", filter data on Open cases??
          this.caseList = data;
          if (data.length < 1) {
            this.showToast({key: 'toast', severity: 'error', detail: 'No case found', summary: 'Info'});
          } else if (data.length === 1) {
            this.onSelect(data[0]); // if only ONE hit, got directly to the Case screen!
          } else {
            this.displayState.gridDiv = true;
          }
        } else {
          this.showToast({key: 'toast', severity: 'error', detail: 'Error retrieving cases', summary: 'Info'});
        }
      });
    }

    searchForCase(searchType: string, searchVal: string) {
        this.utilService.doAudit(searchType + ': ' + searchVal, 'searchForCase');
        this.displayState.gridDiv = false;
        this.displayState.workingDiv = true;
        // this.caseYear = null;   // clear out the year (and the grid data)
        this.caseList = [];
        this.caseService.searchCase(searchType, searchVal).subscribe(data => {
            this.utilService.doAudit(data, 'response from searchCase; type: ' + searchType);
            if (data) {
                // IFF searchType === "appraiser", filter data on Open cases??
                if (searchType === "appraiser") {
                  this.caseList = data.filter(c => c.status.toLowerCase() === "open");
                } else {
                  this.caseList = data;
                }
                if (data.length < 1) {
                    this.showToast({key: 'toast', severity: 'error', detail: 'No case found', summary: 'Info'});
                } else if (data.length === 1) {
                    this.onSelect(data[0]); // if only ONE hit, go directly to the Case screen!
                } else {
                    // this.displayState.gridDiv = true;
                }
              this.displayState.workingDiv = false;
              this.displayState.gridDiv = true;

            }
        });
    }
    onSelect(myCase: ICaseList) {
        const id = myCase.id;
        this.utilService.setArray('case-list', this.caseList);
        this.utilService.setArray('case-filter', [this.searchString]);
        this.router.navigate(['/case/' + id]);
    }

    newCase() {
        this.router.navigate(['/newcase']);
    }

    showAltSearches(flag: boolean) {
      this.utilService.doAudit(flag,'show alt searches flag:');
      this.displayState.altSearches = flag;
    }
    // Toaster/Message-related methods
    showToast(msg: Message) {
        this.messageService.clear('toast');
        this.messageService.add(msg);
    }

    showInfo(myMsg: Message) {
        this.messageService.clear('info');
        this.messageService.add(myMsg);
    }

    clearAll() {
        this.messageService.clear();
    }

    // Excel export-related methods
  exportExcel() {
      const myCols = [['ID', 'Case #', 'Dt Received', 'Applicant', 'Agency', 'Secured', 'APN', 'Situs', 'City', 'Status']];
      this.utilService.exportExcel2(this.caseList, myCols, 'case-list');
  }
}
